import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    otp: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showOTPInput, setShowOTPInput] = useState(false);
  const [isDeactivated, setIsDeactivated] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    setIsDeactivated(false);

    try {
      if (!showOTPInput) {
        // Step 1: Initial login
        const response = await fetch("https://didrouteapi.com/api/users/login", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: formData.email,
            password: formData.password
          }),
        });

        const data = await response.json();

        if (response.ok) {
          setShowOTPInput(true);
        } else {
          if (data.isDeactivated) {
            setIsDeactivated(true);
          }
          setError(data.error || 'Login failed');
        }
      } else {
        // Step 2: Verify OTP
        const response = await fetch("https://didrouteapi.com/api/users/verify-login-otp", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: formData.email,
            otp: formData.otp
          }),
        });

        const data = await response.json();

        if (response.ok) {
          localStorage.setItem('token', data.token);
          navigate('/dashboard');
        } else {
          setError(data.error || 'OTP verification failed');
        }
      }
    } catch (error) {
      setError('Server error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-[-10px]">
      <div className="flex items-center justify-center min-h-screen bg-cover bg-center relative"
        style={{
          backgroundImage: "url(https://images.pexels.com/photos/2150/sky-space-dark-galaxy.jpg?auto=compress&cs=tinysrgb&w=1600)",
        }}>
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative z-10 bg-white bg-opacity-5 backdrop-blur-md shadow-lg rounded-lg max-w-md w-full px-6 py-8 sm:px-10 sm:py-8">
          <div>
           
            <h2 className="text-center text-2xl font-bold leading-9 tracking-tight text-white">
              Sign in to your account
            </h2>
          </div>

          {error && (
            <div className={`mt-4 text-sm text-center ${isDeactivated ? 'text-yellow-500' : 'text-red-500'}`}>
              {error}
              {isDeactivated && (
                <div className="mt-2">
                  Please contact support to reactivate your account.
                </div>
              )}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6 mt-8">
            {!showOTPInput ? (
              <>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-300">
                    Email address
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="mt-1 block w-full rounded-md bg-gray-800 bg-opacity-30 px-4 py-2 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-black"
                    placeholder="Enter your email"
                  />
                </div>

                <div>
                  <label htmlFor="password" className="block text-sm font-medium text-gray-300">
                    Password
                  </label>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    required
                    value={formData.password}
                    onChange={handleChange}
                    className="mt-1 block w-full rounded-md bg-gray-800 bg-opacity-30 px-4 py-2 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-black"
                    placeholder="Enter your password"
                  />
                </div>
              </>
            ) : (
              <div>
                <label htmlFor="otp" className="block text-sm font-medium text-gray-300">
                  Enter OTP
                </label>
                <input
                  id="otp"
                  name="otp"
                  type="text"
                  required
                  value={formData.otp}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md bg-gray-800 bg-opacity-30 px-4 py-2 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-black"
                  placeholder="Enter OTP sent to your email"
                />
              </div>
            )}

            <div>
              <button
                type="submit"
                disabled={loading}
                className={`w-full rounded-md px-4 py-2 text-sm font-medium text-white shadow-sm transition-transform duration-200 ease-in-out transform hover:scale-105
                  ${loading 
                    ? 'bg-gray-500 cursor-not-allowed' 
                    : 'bg-indigo-500 hover:bg-indigo-400'}`}
              >
                {loading ? 'Processing...' : (showOTPInput ? 'Verify OTP' : 'Sign in')}
              </button>
            </div>
          </form>

          <div className="text-sm text-center mt-4">
            <a href="/forgot-password" className="font-semibold text-indigo-400 hover:text-indigo-300">
              Forgot password?
            </a>
          </div>

          <p className="mt-6 text-center text-sm text-gray-400">
            Not a member?{" "}
            <a href="/register" className="font-semibold text-indigo-400 hover:text-indigo-300">
              Register now
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
